export default {
  type: 'Container',
  items: [
    {
      type: 'TextBlock',
      text: '{{cardMessage}}',
      wrap: true,
    },
  ],
};
